import { render, staticRenderFns } from "./gb-whatsapp-old-versions.vue?vue&type=template&id=453f5270&scoped=true"
import script from "./gb-whatsapp-old-versions.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-old-versions.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-old-versions.vue?vue&type=style&index=0&id=453f5270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f5270",
  null
  
)

export default component.exports